import makeStyles from '@mui/styles/makeStyles';
import { CircularProgress, styled } from "@mui/material";

export const LoadingStyled = styled(CircularProgress)(() => ({
  color: "#475467",
}));

export const SSCCTitle = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.10000000149011612px",
  textAlign: "left",
}));

const styles = makeStyles(() => ({
  mainDiv: {
    minHeight: "inherit",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  grid: {
    "& .MuiTableContainer-root": {
      overflowY: "hidden",
      overflowX: "hidden",
    },
    "& .MuiTableBody-root tr.MuiTableRow-root:nth-child(odd)": {
      backgroundColor: "unset !important",
    },
    "& > div > div > div > table > tbody > tr": {
      backgroundColor: "#fff !important",
      "&:not(:last-child)": {
        borderBottom: "1px solid rgba(237, 245, 251, 1) !important",
      },
    },
  },
  leftMargin: {
    marginLeft: "8px",
  },
  actionButton: {
    marginRight: "12px",
    cursor: "pointer",
  },
  buttonSmall: {
    height: "32px",
  },
  printButton: {
    marginTop: "4px",
  },
  createSSCCLabelButton: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    whiteSpace: "nowrap",
  },
  manageSSCCMenuItem: {
    display: "flex",
    flexDirection: "row",
    whiteSpace: "nowrap",
    paddingTop: "10px",
    paddingBottom: "10px",
    fontFamily: "Manrope",
    "&:hover": {
      backgroundColor: "#EDF5FB",
      color: "#308CDB",
      boxShadow: "none",
    },
  },
  mt2px: {
    marginTop: "2px",
  },
  printLabelButton: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    whiteSpace: "nowrap",
  },
  confirmModal: {
    maxWidth: "520px",
    width: "520px",
  },
  confirmModalText: {
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 400,
    marginBottom: "16px",
    color: "#232325",
  },
  confirmModalWarning: {
    fontFamily: "Inter",
    fontStyle: "italic",
    fontSize: "16px",
    fontWeight: 400,
    marginBottom: "16px",
    color: "#308CDB",
  },
  buttonText: {
    whiteSpace: "nowrap",
  },
  roundButton: {
    cursor: "pointer",
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "16px",
    padding: "6px !important",
  },
  defaultPopper: {
    height: "500px",
  },
  rowCenter: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  manageSSCCMenu: {
    width: "151px",
  },
  button: {
    height: "40px",
  },
  menuItem: {
    color: "#667085",
    fontWeight: 600,
    fontSize: "14px",
    fontFamily: "Manrope",
    minWidth: "148px",
    height: "40px",
  },
}));

export default styles;
